import styled from 'styled-components';
import { floatingComponentStyles } from '../../../styles/shareableStyles';
import { theme } from '../../../styles/theme';

export const BaseContainer = styled.div`
  display: flex;
  flex-direction: column;
  word-break: break-word;
  font-size: 12px;
  font-weight: 400;
  line-height: normal;
  color: ${theme.colors.secondary900};
  ${floatingComponentStyles};
`;

export const TitleRow = styled.div<{ $color: string }>`
  flex: 0 0 auto;
  padding: 4px;
  font-size: 14px;
  font-weight: 500;
  color: ${({ $color }) => $color};
`;

export const LabelValuePairRow = styled.div<{ $borderColor?: string }>`
  display: grid;
  grid-template-columns: repeat(2, auto);
  column-gap: 4px;
  padding: 5px 8px 5px 4px;
  border-left: 4px solid ${({ $borderColor }) => $borderColor || 'transparent'};
`;

export const EventValue = styled.div`
  text-align: right;
  font-size: 14px;
  font-weight: 500;
`;

export const NodeValueDisplay = styled.span`
  font-weight: 600;
  color: ${theme.colors.secondary900};
`;
